import { render, staticRenderFns } from "./UserLogin.vue?vue&type=template&id=f5b4754c"
import script from "./UserLogin.vue?vue&type=script&lang=js"
export * from "./UserLogin.vue?vue&type=script&lang=js"
import style0 from "./UserLogin.vue?vue&type=style&index=0&id=f5b4754c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports